/*
Forms start with Foo: | [Foo] | (Foo) or line with ALL_UPPECASE_WORDS SPACES NUMBERS
Chord lines contain [ch]...[/ch]
Diagram lines start with a|-
Everything else is a lyric line

All chords are put into a single measure to be divided by the user.

Returns a quickchords document with a chords flavor.

 */

function parser(src, options) {
  const lines = src.split(/\n/)

  const rxForm = /^(\w+):\s*(.*)/
  const rxForm2 = /^\(([^)]+)\)|\[([^\]]+)\]\s*(.*)/
  const rxChords = /\[ch\]([^\[]+)\[\/ch\]\s*(x\d+)?/gi

  const rxLyrics_Chords = /(\s*)\[ch\]([^\[]+)\[\/ch\](\s*(x\d+))?/gi

  const rxForm3 = /^[A-Z 0-9]+$/

  const rxTabLine = /^\s*[a-zA-Z]\\|-/

  const out = []
  let hasBar = false

  function addDummyBar() {
    // Add dummy bar if section has no content
    if (!hasBar && out.length !== 0) {
      out.push(`;\n\n`)
    }
  }

  if (options.lyrics) {
    out.push(":lyrics+chords\n\n")
  }

  lines.forEach(line => {
    if (options.lyrics) {
      let m = rxLyrics_Chords.exec(line)
      if (m) {
        let s = '';
        while (m) {
          const spaces = m[1].length;
          const symbol = m[2];
          for (let i = 0; i < spaces; i++) {
            s += ' '
          }
          s += symbol
          m = rxLyrics_Chords.exec(line)
        }
        out.push(s);
      } else {
        out.push(line)
      }
      return;
    }

    line = line.trim();
    if (line.length === 0) {
      return;
    }
    const m = rxForm.exec(line)
    if (m) {
      addDummyBar()
      out.push(`(${m[1]})`)
      hasBar = false
      line = m[2]
    } else {
      const m = rxForm2.exec(line)
      if (m) {
        let val = m[1] || m[2];
        if (val !== 'ch') {
          addDummyBar()
          out.push(`(${val})`)
          if (m[3]) {
            line = m[3].trim()
          } else {
            line = ''
          }
          hasBar = false
        }
      } else {
        const m = rxForm3.exec(line)
        if (m) {
          addDummyBar()
          out.push(`(${m[0]})`)
          line = ''
          hasBar = false
        }
      }
    }

    if (rxTabLine.test(line)) {
      return
    }

    const chords = []
    let lyrics

    let mC = rxChords.exec(line)
    if (mC) {
      let i = 0
      while (mC !== null) {
        if (i > 0 && i % 2 === 0) {
          chords.push(';')
        }
        chords.push(mC[1])
        if (mC[2]) {
          chords.push(mC[2])
        }
        mC = rxChords.exec(line)
        i++;
      }
    } else {
      lyrics = line
    }

    if (lyrics && lyrics.length > 0) {
      out.push(`:lyric-line\n${lyrics}\n.\n`)
      //console.log(lyrics)
    } else if (chords.length > 0) {
      if (!hasBar) {
        out.push(`;; ${chords.join(' ')}\n`)
      } else {
        out.push(`; ${chords.join(' ')}\n`)
      }
      hasBar = true
    }
  });

  if (options.lyrics) {
    out.push(".\n")
  } else {
    out.push(';;;')
  }

  let flavor
  if (options.lyrics) {
    flavor = 'lyrics+chords'
  } else {
    flavor = 'chords'
  }

  let header = `:title ${options.title}
:artist ${options.artist}
:flavor ${flavor}

`
  let strDoc = header + out.join('\n');
  return strDoc
}

//const exports = module.exports = {};

export default parser